import React from "react";
import { ModalBody, ModalHeader, ModalFooter, ButtonGroup, Button, Modal } from "reactstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { venueModalDataColumns } from "./dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
const NewVenueModal = ({ isOpen, updateVenueProps, deleteVenueProps, mergeVenueProps, createVenues, newVenues, isVenueCreating }) => {
  const venueRows = newVenues || [];
  const efficiencyEnabledCount = venueRows.filter(venue => venue && venue.efficiency_enabled).length;
  const deleteDraftVenue = index => {
    deleteVenueProps([{ prop: "newVenues." + index }]);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        updateVenueProps([{ prop: "isNewVenueModalOpen", value: !isOpen }]);
      }}
      className="modal-xl venues-modal"
    >
      <ModalHeader
        toggle={() => {
          updateVenueProps([{ prop: "isNewVenueModalOpen", value: !isOpen }]);
        }}
      >
        <div>
          <div className="venues-modal__eyebrow">Venue Intake</div>
          <span className="venues-modal__title">Create Venues</span>
          <div className="venues-modal__helper">
            Add new venues, set scoring, and choose whether they participate in efficiency calculations.
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="venues-modal__body">
        <div className="venues-modal__summary">
          <div className="venues-modal__summary-item">
            <span className="venues-modal__summary-label">Batch</span>
            <span className="venues-modal__summary-value">New venues</span>
          </div>
          <div className="venues-modal__summary-item">
            <span className="venues-modal__summary-label">Rows</span>
            <span className="venues-modal__summary-value">{venueRows.length}</span>
          </div>
          <div className="venues-modal__summary-item">
            <span className="venues-modal__summary-label">Efficiency Enabled</span>
            <span className="venues-modal__summary-value">{efficiencyEnabledCount}</span>
          </div>
        </div>

        <div className="venues-modal__toolbar">
          <ButtonGroup>
          <Button
            color={"faiz1"}
            onClick={() => {
              mergeVenueProps([{ prop: "newVenues", value: [{ name: "", actual_name: "", score: 0, efficiency_enabled: false }] }]);
            }}
          >
            <i className={"fa fa-plus"} /> Add Venue
          </Button>
        </ButtonGroup>
        </div>

        <div className="venues-modal__workspace">
          <div className="venues-modal__workspace-header">
            <div>
              <div className="venues-modal__workspace-title">Batch Editor</div>
              <div className="venues-modal__workspace-copy">
                Enter venue labels, actual display names, scores, and efficiency participation in one grid.
              </div>
            </div>
          </div>

          <div className="venues-modal__table-shell">
        <ReactTable
          data={venueRows}
          columns={venueModalDataColumns(updateVenueProps, deleteDraftVenue)}
          className="-highlight -striped venues-table"
          defaultPageSize={5}
          filterable
        />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => {
            // updateVenueProps([{ prop: "isNewVenueModalOpen", value: !isOpen }]);
            createVenues(newVenues);
          }}
        >
          {isVenueCreating ? (
            <>
              <Spinner size={10} animating={true} color={"white"} />
              &nbsp;
            </>
          ) : null}
          Create
        </Button>{" "}
        <Button
          color="secondary"
          onClick={() => {
            updateVenueProps([{ prop: "isNewVenueModalOpen", value: !isOpen }, { prop: "newVenues", value: [] }]);
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default NewVenueModal;
